import { useEffect, useState } from "react";
import { useParams, Link, useSearchParams } from "react-router-dom";
import { Hexagon, CalendarClock } from "lucide-react";
import { api } from "@/lib/api";
import { DemoRenderer } from "@/components/demo/templates";

const StateScreen = ({ icon: Icon, title, text, testid }) => (
  <div className="grid-bg flex min-h-screen flex-col items-center justify-center gap-4 bg-ink px-4 text-center" data-testid={testid}>
    <Icon className="h-12 w-12 text-cy" strokeWidth={1.2} />
    <h1 className="font-display text-2xl font-bold text-slate-100">{title}</h1>
    <p className="max-w-md text-sm text-slate-400">{text}</p>
    <Link to="/" className="mt-2 rounded-full bg-cy px-6 py-3 font-display text-sm font-bold text-ink transition-colors hover:bg-em" data-testid="demo-state-home">
      Ir a Quantum Century
    </Link>
  </div>
);

export default function DemoPreview() {
  const { slug } = useParams();
  const [searchParams] = useSearchParams();
  const present = searchParams.get("present") === "1";
  const [demo, setDemo] = useState(null);
  const [state, setState] = useState("loading");

  useEffect(() => {
    api
      .get(`/demos/preview/${slug}`)
      .then((r) => {
        setDemo(r.data);
        document.title = `${r.data.business_name} — Demo por Quantum Century`;
      })
      .catch((e) => setState(e.response?.status === 410 ? "expired" : "notfound"));
  }, [slug]);

  if (state === "expired") {
    return (
      <StateScreen
        icon={CalendarClock}
        testid="demo-expired"
        title="Esta demo ha expirado"
        text="El período de revisión de esta propuesta terminó. Si eres cliente de Quantum Century y deseas reactivarla, contáctanos."
      />
    );
  }

  if (state === "notfound") {
    return (
      <StateScreen
        icon={Hexagon}
        testid="demo-not-found"
        title="Esta demo ya no está disponible"
        text="El enlace pudo haber sido retirado. Si eres cliente de Quantum Century, contáctanos para reactivarlo."
      />
    );
  }

  if (!demo) {
    return (
      <div className="flex min-h-screen items-center justify-center bg-ink" data-testid="demo-loading">
        <p className="animate-pulse font-mono text-xs tracking-[0.3em] text-cy">CARGANDO DEMO…</p>
      </div>
    );
  }

  return (
    <div data-testid="demo-preview" className={present ? "present-mode" : ""}>
      <DemoRenderer demo={demo} />
    </div>
  );
}
